import script from "./BlogView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogView.vue?vue&type=script&setup=true&lang=ts"

import "./BlogView.vue?vue&type=style&index=0&id=94de960a&lang=scss"

const __exports__ = script;

export default __exports__